import { Badge, Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import type { ContactRelation } from './contact-relation';

interface ContactRelationBadgeProps {
  relation: ContactRelation;
}

/**
 * Pill under the contact's name saying how the brand stands with them: green
 * with a dot for an affiliate, gray for a prospect.
 */
const ContactRelationBadge: React.FC<ContactRelationBadgeProps> = ({ relation }) => {
  const { t } = useTranslation();
  const isAffiliate = relation === 'affiliate';

  return (
    <Badge colorPalette={isAffiliate ? 'green' : 'gray'}>
      {isAffiliate && (
        <Box as="span" boxSize="6px" rounded="full" bg="colorPalette.solid" aria-hidden />
      )}
      {isAffiliate
        ? t('contactDrawer.rail.relation.affiliate')
        : t('contactDrawer.rail.relation.prospect')}
    </Badge>
  );
};

export default ContactRelationBadge;
